// import image1 from "../Images/image1.png";
import service from "../service.jpg";
import tata1mg from "../tata1mg.jpg";
import blueapron from "../blueapron.jpg";
import quiz from "../quiz.png"


export const projectsList = [
  {
    id: 1,
    name: "Tata1mg ",
    liveLink: "https://health-care-tau.vercel.app/",
    githubLink: "https://github.com/prachi913/chemical-rake-3857",
    image: tata1mg,
    techStacks: ["react", "redux", "chakra ui", "firebase", "json-servor"],

    desc: `this is a clone of Tata1mg, Tata1mg is a healthcare platform in India which provide medicine ,you can order from anywhere it will come to your door
`,
  },
  {
    id: 2,
    name: "Urban Company",
    liveLink: "https://amazing-alfajores-a43c73.netlify.app/",
    githubLink: "https://github.com/prachi913/wholesale-territory-1714",
    image: service,
    techStacks: ["HTML", "CSS", "Javascript", "json-servor"],
    desc: `this is clone of Urban Company,it provides a platform that allows experienced professionals to connect with users looking for specific services`,
  },
  {
    id: 3,
    name: "Blue Apron",
    liveLink:
      "https://6459e8fd857dc1267d723dd6--dancing-elf-b8f83a.netlify.app/",
    githubLink: "https://github.com/prachi913/snazzyy-cars-9581",
    image: blueapron,
    techStacks: ["react.js", "redux", "chakra ui", "reqres", "json-servor"],
    desc: `Blue Apron meal delivery services offer meal kits with fresh ingredients,and it's deliver fresh food and any time you can orfer from here `,
  },
  {
    id: 4,
    name: "Play Quiz",
    liveLink: "https://vermillion-profiterole-ffc66f.netlify.app/?",
    githubLink: "https://github.com/prachi913/quiz/tree/main/quiz",
    image: quiz,
    techStacks: ["HTML", "CSS", "Javascript"],
    desc: `This is multiplication quiz, here u can play and get score and if you do mistake you will lose a point and after correct you will get one score .  `,
  },
];
